import { Grid, Tab, Tabs } from "@mui/material";
import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { PAGE_VISITED } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";

import FindCreator from "./FindCreator";
import TrackCreators from "./TrackCreators";

export default function InstagramDashboardPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = location.pathname.includes("/track") ? "track" : "find";

  const handleTabChange = (_: any, newValue: string) => {
    navigate(newValue);
  };

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Tabs
          sx={{ px: 1 }}
          variant="scrollable"
          scrollButtons="auto"
          value={currentTab}
          onChange={handleTabChange}
        >
          <Tab value="find" label="Find" />
          <Tab value="track" label="Tracking" />
        </Tabs>
      </Grid>

      <Routes>
        <Route index element={<Navigate to="find" replace />} />
        <Route path="find" element={<FindCreator />} />
        <Route path="track" element={<TrackCreators />} />
      </Routes>
    </Grid>
  );
}
